import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bs-detour-menu-element',
  templateUrl: './detour-menu-element.component.html',
  styleUrls: ['./detour-menu-element.component.css']
})
export class DetourMenuElementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
